import React, { useState } from 'react';

const WhatsAppChatButton = () => {
  const phoneNumber = '+919044744659'; // Replace with your actual phone number
  const message = 'Hello, We would like to know more about the Services.'; // Pre-filled message (optional)

  const [showBubble, setShowBubble] = useState(false);

  const handleMouseEnter = () => setShowBubble(true);
  const handleMouseLeave = () => setShowBubble(false);

  const whatsAppLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  return (
    <a
      href={whatsAppLink}
      target="_blank"
      className="float"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <i className="fa fa-whatsapp my-float"></i>
      {showBubble && <span className="chat-bubble">Let's Chat!</span>}
    </a>
  );
};

export default WhatsAppChatButton;
